export const UPDATE_TEMPLATE_CTA_STATE = "UPDATE_TEMPLATE_CTA_STATE"
export const TC_MORE_TEMPLATE_LOADED = "TC_MORE_TEMPLATE_LOADED"
export const TC_CREATED = "TC_CREATED"
export const TC_DELETED = "TC_DELETED"
export const TC_UPDATED = "TC_UPDATED"
